/* NEW CITY · scorrimento più lento e morbido su smartphone (Lenis 1.3.26, caricato da sections/nc-promo-banner.liquid).
   I banner usano window.ncLenis per fermare la pagina al centro. Su PC lo scorrimento resta quello normale. */
(function () {
  if (window.ncLenis || !window.Lenis || !window.gsap || (window.Shopify && Shopify.designMode)) return;
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  /* scorrimento nativo solo nei pannelli scorrevoli dentro livelli fissi (carrello, popup): il resto della pagina è sempre
     gestito da Lenis, così su iPhone non parte mai l'inerzia nativa che può far "saltare" i banner */
  var memo = new WeakMap();
  function nativeArea(node) {
    var m = memo.get(node), now = Date.now();
    if (m && now - m.t < 1500) return m.v;
    var v = false, cs = getComputedStyle(node);
    if (/(auto|scroll|overlay)/.test(cs.overflowY) && node.scrollHeight > node.clientHeight + 2) {
      for (var p = node; p && p !== document.body; p = p.parentElement) {
        if (getComputedStyle(p).position === 'fixed') { v = true; break; }
      }
    }
    memo.set(node, { t: now, v: v });
    return v;
  }
  var lenis = new Lenis({
    syncTouch: true,            /* anche lo scorrimento col dito passa da Lenis */
    touchMultiplier: 1,         /* la pagina segue il dito 1:1 */
    touchInertiaExponent: 1.75, /* slancio quando si lascia il dito */
    syncTouchLerp: 0.1,         /* risposta dello slancio: più alto = più reattivo */
    lerp: 0.09,
    prevent: nativeArea,
    respectReducedMotion: false
  });
  window.ncLenis = lenis;
  if (window.ScrollTrigger) lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
  gsap.ticker.lagSmoothing(0);
  /* un tocco per fermare lo slancio non deve aprire il link che si trova sotto il dito */
  var guardUntil = 0;
  window.addEventListener('touchstart', function () {
    if (Math.abs(lenis.velocity) > 1.5) guardUntil = Date.now() + 500;
  }, { capture: true, passive: true });
  document.addEventListener('click', function (e) {
    if (Date.now() < guardUntil) { e.preventDefault(); e.stopPropagation(); guardUntil = 0; }
  }, true);
})();